import React from "react";
import { useChat } from "../../Hooks/ChatContext";
import ChatList from "./ChatList";
import ChatRight from "./ChatRight";
import { is_small_screen } from "src/utils/constants";
import { useNavigate } from "react-router-dom";
import { gr } from "src/design-system/tokens";
import GrPage from "src/design-system/components/GrPage";
import GrPageHeader from "src/design-system/components/GrPageHeader";
import GrButton from "src/design-system/components/GrButton";
import GrCountBadge from "src/design-system/components/GrCountBadge";
import GrIcon from "src/design-system/components/GrIcon";
import icons from "src/design-system/icons";
import GrCard from "src/design-system/components/GrCard";

// One card split in two panes; its height fits the viewport so the composer stays visible.
// The offset is the app bar + page header above the card plus a small gap below it.
const paneCardSx = {
  p: 0,
  "@media (max-width: 599.95px)": { p: 0 },
  display: "grid",
  gridTemplateColumns: "minmax(280px, 340px) minmax(0, 1fr)",
  // 161 = app bar + page frame top (GrPage 16) + page header above the card + a 24px gap below it;
  // the page itself does not scroll.
  // dvh where supported, so the composer never sits under a mobile browser's URL bar.
  height: "calc(100vh - 161px)",
  "@supports (height: 100dvh)": { height: "calc(100dvh - 161px)" },
  minHeight: 360,
  overflow: "hidden",
  // 500–767px (tablet portrait): list on top, conversation below, instead of a squeezed 2nd column.
  "@media (max-width: 767.95px)": {
    gridTemplateColumns: "minmax(0, 1fr)",
    gridTemplateRows: "minmax(0, 40%) minmax(0, 1fr)",
  },
};

const phoneCardSx = {
  p: 0,
  "@media (max-width: 599.95px)": { p: 0 },
  display: "flex",
  flexDirection: "column",
  height: "calc(100vh - 206px)",
  "@supports (height: 100dvh)": { height: "calc(100dvh - 206px)" },
  minHeight: 360,
  overflow: "hidden",
};

function Chat() {
  const navigate = useNavigate();
  const { selectedChat, receiverCount } = useChat();
  const small = is_small_screen();
  return (
    // mb -10 cancels the layout's 80px bottom padding (MainStyle) so the card can fill the screen.
    <GrPage sx={{ mb: -10, pb: gr.space[6] }}>
      <GrPageHeader
        title="Messages"
        sx={{ mb: gr.space[4] }}
        actions={
          // Teal outline + icon so it reads as a clear action (grey secondary looked inactive).
          <GrButton
            variant="outline"
            startIcon={<GrIcon icon={icons.people} />}
            onClick={() => {
              navigate("/chat/friend-list");
            }}
          >
            Friends
            <GrCountBadge
              count={receiverCount}
              tone="alert"
              label={`${receiverCount} friend requests`}
            />
          </GrButton>
        }
      />
      <GrCard as="div" sx={small ? phoneCardSx : paneCardSx}>
        {(!small || (small && !selectedChat?._id)) && <ChatList />}
        {(!small || (small && selectedChat?._id)) && <ChatRight />}
      </GrCard>
    </GrPage>
  );
}

export default Chat;
